export type { GetArticleQuizInput } from './get-article-quiz'
export { getArticleQuiz } from './get-article-quiz'
export type { ArticleQuizConfig, ResolvedArticleQuiz } from './types'
